<div class="footer-container">
  <div class="links">
    <a href="#">Contact Us</a> |
    <a href="assets/documents/terms-of-service.pdf" target="_blank"
      >Terms of Service</a
    >
    |
    <a href="assets/documents/privacy-policy.pdf" target="_blank"
      >Privacy Policy</a
    >
  </div>
  <div class="copyright">
    &copy; {{ copyrightYear }} STEMTaught.com
    <ng-container *ngIf="clientEnvironment">
      v{{ clientEnvironment.version }} {{ clientEnvironment.environment }}
    </ng-container>
  </div>
</div>
